export function parseUTC(iso) {
    if (!iso)
        return new Date();
    const s = iso.endsWith('Z') || iso.includes('+') ? iso : iso + 'Z';
    return new Date(s);
}
export function formatLocalTime(iso) {
    if (!iso)
        return '—';
    return parseUTC(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}
export function formatCurrency(value) {
    const abs = Math.abs(value);
    const formatted = abs.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    if (value < 0) {
        return `-$${formatted}`;
    }
    return `$${formatted}`;
}
export function formatPercent(value, decimals = 2) {
    const percent = value * 100;
    return `${percent.toFixed(decimals)}%`;
}
export function formatPnLPercent(value, decimals = 2) {
    if (value > 0) {
        return `+${value.toFixed(decimals)}%`;
    }
    return `${value.toFixed(decimals)}%`;
}
export function formatPrice(value) {
    return value.toFixed(4);
}
export function formatTimestamp(isoString) {
    try {
        return parseUTC(isoString).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
    }
    catch (e) {
        return isoString;
    }
}
export function formatDate(isoString) {
    try {
        const date = parseUTC(isoString);
        return date.toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        });
    }
    catch (e) {
        return isoString;
    }
}
export function formatDuration(hours) {
    if (hours < 1) {
        const minutes = Math.round(hours * 60);
        return `${minutes}m`;
    }
    if (hours < 24) {
        const h = Math.floor(hours);
        const m = Math.round((hours - h) * 60);
        return m > 0 ? `${h}h ${m}m` : `${h}h`;
    }
    const days = Math.floor(hours / 24);
    const remainingHours = Math.floor(hours % 24);
    return remainingHours > 0 ? `${days}d ${remainingHours}h` : `${days}d`;
}
export function formatCompact(value) {
    const abs = Math.abs(value);
    const sign = value < 0 ? '-' : '';
    if (abs < 1000) {
        return `${sign}${abs.toFixed(0)}`;
    }
    if (abs < 1000000) {
        return `${sign}${(abs / 1000).toFixed(2)}K`;
    }
    return `${sign}${(abs / 1000000).toFixed(2)}M`;
}
export function getPnLClass(value) {
    if (value > 0)
        return 'positive';
    if (value < 0)
        return 'negative';
    return 'neutral';
}
export function truncate(str, maxLength) {
    if (str.length <= maxLength)
        return str;
    return str.slice(0, maxLength - 3) + '...';
}
export function formatMarketType(type) {
    if (!type)
        return '—';
    return type
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
export function formatExitType(type) {
    if (!type)
        return '—';
    return type
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
//# sourceMappingURL=formatting.js.map